var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import angular from 'angular';
import { Component } from 'decorators';
import view from './answer.view.html';
import './answer.scss';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { BuilderStore } from 'modules/application/detail/portal-submodule-builder/templates/builder/store/BuilderStore';
import { CardOutputContentIAction } from 'modules/application/detail/portal-submodule-builder/templates/builder/historyActions';
import { OutputAddNewState, OutputChange, OutputUpdateAndSaveState } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { variableValueForward } from 'modules/application/detail/portal-submodule-builder/templates/builder/aiAgent/state/Outputs';
import { immutableSplice } from 'data/array';
import { insertAtPosition } from 'modules/shared/helpers/Array';
import { ActionType } from '../../../../../models/Action';
import { VARIABLE_VALIDATION_REGEX } from '../../../../../models/validators/Validator';
import { AgentHandoffService } from '../../../../services/AgentHandoffService';
const builderStore = BuilderStore.getInstance();
let AnswerComponent = class AnswerComponent {
    static $inject = ['$timeout', 'UndoRedoService', 'AgentHandoffService'];
    //#endregion
    constructor($timeout, UndoRedoService, AgentHandoffService) {
        //#endregion
        //#region Component State
        this.schemaString = '';
        this.isValidVariableFormat = true;
        //#region Lifecycle Hooks
        this.$onInit = () => {
            this.outputConfiguration.output.forward = this.outputConfiguration.output.forward
                || { enabled: true, outputVariable: '', handoffName: '' };
            if (this.outputConfiguration.output.forward.enabled === undefined) {
                this.outputConfiguration.output.forward.enabled = true;
            }
            this.forwardToContact = this.outputConfiguration.output?.forward.enabled;
            this.updateFilteredStates();
            this.fillForwardOutput();
            this.checkFeatures();
            this.schemaString = JSON.stringify(this.outputConfiguration.output?.contentTypes.custom.schema || {}, null, 2);
        };
        this.onToggleUserForward = () => {
            this.outputConfiguration.output.forward.enabled = !this.outputConfiguration.output.forward.enabled;
            this.forwardToContact = this.outputConfiguration.output.forward.enabled;
            if (this.forwardToContact) {
                this.deleteOutput();
            }
        };
        this.onChangeVariableName = (event) => {
            this.outputConfiguration.output.forward.outputVariable = event.detail.value;
            this.isValidVariableFormat = VARIABLE_VALIDATION_REGEX.test(this.outputConfiguration.output.forward.outputVariable);
        };
        this.onToggleContentType = (contentType) => {
            if (!this.outputConfiguration.output.forward.enabled) {
                return;
            }
            const keys = Object.keys(this.outputConfiguration.output.contentTypes).filter(key => key !== 'custom');
            const selectedContentTypes = contentType.detail.map(item => item.value);
            for (const key of keys) {
                this.outputConfiguration.output.contentTypes[key].enabled = selectedContentTypes.includes(key);
            }
        };
        this.onToggleCustomContentType = (contentType) => {
            const customToggled = contentType.detail.length > 0;
            this.outputConfiguration.output.contentTypes.custom.enabled = customToggled;
            if (customToggled) {
                this.$timeout(() => {
                    this.editor.layout();
                }, 2000);
            }
        };
        this.onCodeChange = ({ code }) => {
            try {
                this.outputConfiguration.output.contentTypes.custom.schema = JSON.parse(code);
            }
            catch (error) {
                // Keep invalid JSON for user editing, don't update schema object
            }
        };
        this.updateFilteredStates = () => {
            if (!this.states) {
                throw new Error('States object is undefined in AnswerComponent. Ensure that the "states" binding is provided.');
            }
            if (this.state.id === undefined) {
                throw new Error('State ID is undefined in AnswerComponent. Ensure that the "state" binding has a valid "id" property.');
            }
            this.filteredStates = angular.copy(this.states);
            delete this.filteredStates[this.state.id];
        };
        this.didCreateEditor = (event) => {
            this.$timeout(() => {
                if (event && event.editor) {
                    this.editor = event.editor;
                    this.$timeout(() => {
                        this.editor.layout();
                    }, 1000);
                    // disable minimap
                    this.editor.updateOptions({
                        minimap: {
                            enabled: false,
                        },
                    });
                }
            }, 2000);
        };
        this.$timeout = $timeout;
        this.UndoRedoService = UndoRedoService;
        this.AgentHandoffService = AgentHandoffService;
    }
    //#endregion
    //#region Methods
    async $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
    }
    async checkFeatures() {
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
    }
    fillForwardOutput() {
        const index = this.getForwardOutputIndex();
        if (index >= 0) {
            this.forwardOutput = this.state.$conditionOutputs[index];
        }
    }
    async deleteOutput() {
        try {
            const index = this.getForwardOutputIndex();
            this.addHandoffOnConfiguration(null);
            this.forwardOutput.stateId = '';
            if (index < 0) {
                return;
            }
            const output = this.state.$conditionOutputs[index];
            this.state.$conditionOutputs = immutableSplice(this.state.$conditionOutputs, index, 1);
            builderStore.setState({ ...this.state });
            const action = new OutputChange({
                state: this.state,
                output: output,
                newTarget: output.stateId,
            });
            await this.$dispatch(action);
            this.validateTabAndSaveState();
        }
        catch (ex) {
            console.log('error during remove output', ex);
        }
    }
    addOutput() {
        const output = this.AgentHandoffService.createHandoffOutput(variableValueForward, {
            $isAgentCustomOutput: false,
            $isAgentDefaultOutput: false,
        });
        this.state.$conditionOutputs = this.state.$conditionOutputs.concat(output);
        const currentState = angular.copy(this.state);
        builderStore.setState({ ...currentState });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.createOutputUndoRedoAction(output));
        }
        this.validateTab();
    }
    async addNewState({ label, oldTarget }) {
        const defaultOutput = this.state.$conditionOutputs.find(out => out.$isAgentDefaultOutput);
        const action = new OutputAddNewState({
            output: defaultOutput,
            state: this.state,
            newTarget: label,
            oldTarget,
        });
        this.addHandoffOnConfiguration(label);
        await this.$dispatch(action);
        this.validateTabAndSaveState();
    }
    addHandoffOnConfiguration(label) {
        this.state.$enteringCustomActions
            .find(action => action.type === ActionType.ForwardToAgent)
            .settings.output.forward.handoffName = label;
    }
    validateTab() {
        const outputsTabElement = document.getElementById('content-tab-1');
        if (outputsTabElement) {
            if (this.state.$invalidOutputs) {
                outputsTabElement.classList.add('invalid-background');
            }
            else {
                outputsTabElement.classList.remove('invalid-background');
            }
        }
    }
    onUpdateAndSaveState() {
        const action = new OutputUpdateAndSaveState();
        this.$dispatch(action);
    }
    validateTabAndSaveState() {
        this.onUpdateAndSaveState();
        this.validateTab();
    }
    getForwardOutputIndex() {
        return this.AgentHandoffService.getHandoffOutputIndex(this.state.$conditionOutputs, variableValueForward);
    }
    async changeOutput({ newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId }) {
        let outputIndex = this.getForwardOutputIndex();
        if (outputIndex < 0) {
            outputIndex = this.state.$conditionOutputs.length;
            this.addOutput();
        }
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.changeOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId, outputIndex));
        }
        this.state.$conditionOutputs[outputIndex].typeOfStateId = newTypeOfStateId;
        this.state.$conditionOutputs[outputIndex].stateId = newTarget;
        this.addHandoffOnConfiguration(newTarget);
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
        });
    }
    changeOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId, index) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                defaultOutput: oldTarget,
                newDefaultTarget: newTarget,
                newTypeOfStateId,
                oldTypeOfStateId,
            },
            execute: (data) => {
                this.state.$conditionOutputs[index].typeOfStateId = data.newTypeOfStateId;
                this.state.$conditionOutputs[index].stateId = data.newDefaultTarget;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
            undo: (data) => {
                this.state.$conditionOutputs[index].typeOfStateId = data.oldTypeOfStateId;
                this.state.$conditionOutputs[index].stateId = data.defaultOutput;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
        });
    }
    createOutputUndoRedoAction(output) {
        const outputIndex = this.state.$conditionOutputs.map((co) => co.$id).indexOf(output.$id);
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                }
            },
            execute: (data) => {
                const currentEditingState = angular.copy(this.state);
                const currentConditionalOutputs = builderStore.getState(data.state.id).$conditionOutputs;
                const newState = {
                    ...currentEditingState,
                    $conditionOutputs: insertAtPosition(currentConditionalOutputs, output, outputIndex)
                };
                builderStore.setState(newState);
                this.validateTab();
            },
            undo: (data) => {
                const state = builderStore.getState(data.state.id);
                const newState = {
                    ...state,
                    $conditionOutputs: immutableSplice(state.$conditionOutputs, outputIndex, 1)
                };
                builderStore.setState(newState);
                this.validateTab();
            },
        });
    }
};
AnswerComponent.$inject = ['$timeout', 'UndoRedoService', 'AgentHandoffService'];
AnswerComponent = __decorate([
    Component({
        template: view,
        controllerAs: '$ctrl',
        bindings: {
            onAction: '&?',
            outputConfiguration: '<',
            state: '=?',
            states: '=?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof angular !== "undefined" && angular.ITimeoutService) === "function" ? _a : Object, typeof (_b = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _b : Object, typeof (_c = typeof AgentHandoffService !== "undefined" && AgentHandoffService) === "function" ? _c : Object])
], AnswerComponent);
export { AnswerComponent };
